 
import React, { Component} from 'react';

//import { getFirestore, collection, getDocs } from 'firebase/firestore/lite';

import Header from "../layout/header"
import Footer from "../layout/footer"
import Menu from "../layout/doctorLeftmenu"
import {Link} from "react-router-dom"; 
//import $ from 'jquery';
import editImg from "../images/edit.png"
import deleteImg from "../images/delete.png"
import {db,database,courseRef} from '../firebase'

export default class Insights extends Component {
  constructor(props) {
    super(props)
    this.state = {
        insightData:[], 
    }
  
}

componentDidMount(){
 this.renderList();
 
}

async  renderList(){
  
  let dataList=[]
  await database.ref("Course").once('value',function(snapshot){
     snapshot.forEach(
      function(ChildSnapshot){
        dataList.push({key:ChildSnapshot.key,CourseName:ChildSnapshot.val().CourseName
        
        } )      
      }
    )
  })
this.setState({insightData:dataList})
}

editData(key){

  this.props.history.push("/newInsights/keyId="+key);
  
  
}

deleteData(key){
  database.ref(`Course/${key}`).remove()
  .then(()=>{
    alert("Deleted Successfully")
    this.renderList();
  }).catch(()=>{
    alert("Somthing went wrong")
  })

}

    render() {

    return (

      <div className="main-wrapper">
        <Header></Header>
        <div className="main-content">    
        <Menu></Menu>    
          <div className="content-right-wrapper">
            <div className="container">
              <div className='form-wrapper'>
                <ul className="breadcrumb">
                    <li><a href="/dashboard">Dashboard</a></li>
                    <li>Career Tracks</li>
                </ul>
                <div className='form-head'>
                Career Tracks
                  <Link to="/newCourse/keyId=0"><button className='addNewBtn btn'> New Courses</button></Link>
                </div>
                <div className='table'>
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th scope="col">No</th>
                        <th scope="col">Courses Name</th>            
                       
                        <th scope="col">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.renderList}
                      {this.state.insightData.map((data, i) => {
                    
                         return (
                      <tr>
                        <th scope="row">{i+1}</th>
                        <td>{data.CourseName}</td>                      
                        
                        <td>
                          <Link to={'/newCourse/keyId='+data.key} params={data.key}>
                          <img src={editImg} className='actionIcon' ></img>
                          </Link>
                          <img src={deleteImg} className='actionIcon' onClick={()=>this.deleteData(data.key)}></img>
                        </td>
                      </tr>
                         )})}
                      
                    </tbody>
                  </table>
                </div>
                {/* <div>
                  <nav aria-label="Page navigation example">
                    <ul className="pagination justify-content-end">
                      <li className="page-item">
                        <a className="page-link" href="#" aria-label="Previous">
                          <span aria-hidden="true">&laquo;</span>
                          <span className="sr-only">Previous</span>
                        </a>
                      </li>
                      <li className="page-item"><a className="page-link" href="#">1</a></li>
                      <li className="page-item"><a className="page-link" href="#">2</a></li>
                      <li className="page-item"><a className="page-link" href="#">3</a></li>
                      <li className="page-item">
                        <a className="page-link" href="#" aria-label="Next">
                          <span aria-hidden="true">&raquo;</span>
                          <span className="sr-only">Next</span>
                        </a>
                      </li>
                    </ul>
                  </nav>
                </div> */}
              </div>
            </div>
            
          </div>
        </div>
        
        <Footer></Footer>
      </div>
      )
    }
}


// WEBPACK FOOTER //
// ./src/CareerTracks/career-tracks-save.jsx